<template>
  <el-card>
    <el-tabs v-model="activeTab" tab-position="right" class="fiches-tabs" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('fiches.ficheEngagement')" name="contrats">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesEngagement') }}</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.contrats">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.contrats.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <!-- Sélections hiérarchiques des localités -->
            <el-form-item label="Région">
              <el-select v-model="filters.contrats.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('contrats')">
                <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Zone">
              <el-select v-model="filters.contrats.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('contrats')">
                <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Commune">
              <el-select v-model="filters.contrats.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('contrats')">
                <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Village">
              <el-select v-model="filters.contrats.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('contrats')">
                <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.contrats.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('contrats')">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.contrats.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" :loading="downloading" @click="download('contrats')">Télécharger</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Fiches de formation" name="formation">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesFormation') }}</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.formations">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.formations.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Controleur">
              <el-select v-model="filters.formations.controleur" class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="(cont, index) in controleurs" :key="index" :label="uppercaseFirst(cont.nom)" :value="cont.id" :disabled="!cont.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" :loading="downloading" @click="download('formations')">Télécharger</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Fiches de contrôle interne" name="controle_interne">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesControlleInterne') }}</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.controle_interne">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.controle_interne.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <!-- Sélections hiérarchiques des localités -->
            <el-form-item label="Région">
              <el-select v-model="filters.controle_interne.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('controle_interne')">
                <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Zone">
              <el-select v-model="filters.controle_interne.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('controle_interne')">
                <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Commune">
              <el-select v-model="filters.controle_interne.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('controle_interne')">
                <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Village">
              <el-select v-model="filters.controle_interne.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('controle_interne')">
                <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.controle_interne.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('controle_interne')">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.controle_interne.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList('controle_interne')">
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.controle_interne.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" :loading="downloading" @click="download('controle_interne')">Télécharger</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Fiches parcellaire" name="parcellaire">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesParcellaire') }}</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.parcellaire">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.parcellaire.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <!-- Sélections hiérarchiques des localités -->
            <el-form-item label="Région">
              <el-select v-model="filters.parcellaire.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('parcellaire')">
                <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Zone">
              <el-select v-model="filters.parcellaire.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('parcellaire')">
                <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Commune">
              <el-select v-model="filters.parcellaire.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('parcellaire')">
                <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Village">
              <el-select v-model="filters.parcellaire.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('parcellaire')">
                <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.parcellaire.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('parcellaire')">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.parcellaire.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList('parcellaire')">
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.parcellaire.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" :loading="downloading" @click="download('parcellaire')">Télécharger</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Fiches de bon de livraison" name="bon_livraison">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>

        <div v-else>
          <div class="page-title">
            <h2>Fiches de bon de livraison</h2>
          </div>

          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>

          <el-form :inline="true" :model="filters.bon_livraison">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.bon_livraison.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <!-- Sélections hiérarchiques des localités -->
            <el-form-item label="Région">
              <el-select v-model="filters.bon_livraison.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('bon_livraison')">
                <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Zone">
              <el-select v-model="filters.bon_livraison.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('bon_livraison')">
                <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Commune">
              <el-select v-model="filters.bon_livraison.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('bon_livraison')">
                <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Village">
              <el-select v-model="filters.bon_livraison.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('bon_livraison')">
                <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.bon_livraison.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('bon_livraison')">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.bon_livraison.groupement" placeholder="Sélectionner" filterable @change="getGroupProducteursList('bon_livraison')">
                <el-option v-for="item in groupements" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.bon_livraison.producteur" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="`${item.nom} ${item.prenom}`" :value="item.id" />
              </el-select>
            </el-form-item>

            <el-form-item label="Période">
              <el-date-picker
                v-model="filters.bon_livraison.dateRange"
                type="daterange"
                range-separator="à"
                start-placeholder="Date début"
                end-placeholder="Date fin"
                format="dd/MM/yyyy"
              />
            </el-form-item>
          </el-form>

          <el-button type="primary" :loading="downloading" @click="download('bon_livraison')">
            Télécharger
          </el-button>
        </div>
      </el-tab-pane>

      <!-- <el-tab-pane label="Fiches de bon de livraison" name="bon_livraison">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>Fiches de bon de livraison</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.bon_livraison">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.bon_livraison.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.bon_livraison.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.bon_livraison.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList">
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.bon_livraison.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" :loading="downloading" @click="download('bon_livraison')">Télécharger</el-button>
        </div>
      </el-tab-pane> -->

      <!-- <el-tab-pane label="Fiches collectes" name="collecte">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesCollecte') }}</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.collecte">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.collecte.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.collecte.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.collecte.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList">
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.collecte.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="download('collecte')">Télécharger</el-button>
        </div>
      </el-tab-pane> -->
      <el-tab-pane label="Fiches collectes" name="collecte">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesCollecte') }}</h2>
          </div>

          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>

          <el-form :inline="true" :model="filters.collecte">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.collecte.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <!-- Sélections hiérarchiques des localités -->
            <el-form-item label="Région">
              <el-select v-model="filters.collecte.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('collecte')">
                <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Zone">
              <el-select v-model="filters.collecte.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('collecte')">
                <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Commune">
              <el-select v-model="filters.collecte.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('collecte')">
                <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Village">
              <el-select v-model="filters.collecte.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('collecte')">
                <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.collecte.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('collecte')">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.collecte.groupement" placeholder="Sélectionner" filterable @change="getGroupProducteursList('collecte')">
                <el-option v-for="item in groupements" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.collecte.producteur" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>

            <el-form-item label="Certification">
              <el-input v-model="filters.collecte.certification" placeholder="Ex: BIO, RA..." clearable />
            </el-form-item>

            <el-form-item label="Période">
              <el-date-picker
                v-model="filters.collecte.dateRange"
                type="daterange"
                range-separator="à"
                start-placeholder="Date début"
                end-placeholder="Date fin"
                format="dd/MM/yyyy"
              />
            </el-form-item>
          </el-form>

          <el-button type="primary" icon="el-icon-download" @click="download('collecte')">
            Télécharger les fiches
          </el-button>
        </div>
      </el-tab-pane>

    </el-tabs>
  </el-card>
</template>

<script>
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role';
import { ref, reactive } from 'vue';

const uniteProdResource = new Resource('unite_productions');
const campResource = new Resource('campagne_agricoles');
const downloadResource = new Resource('downloads');
const controleurResource = new Resource('controleurs');
const groupementProducteurResource = new Resource('groupement_producteurs');
const villageResource = new Resource('villages');
const regionResource = new Resource('regions');
const zoneResource = new Resource('zones');
const communeResource = new Resource('communes');
export default {
  name: 'Download',
  directives: { waves, permission, role },
  data() {
    return {
      unite_productions: null,
      campagnes_agricoles: null,
      controleurs: [],
      groupements: [],
      producteurs: [],
      villages: [],
      regions: [],
      zones: [],
      communes: [],
      downloading: false,
      loading: true,
      uniteProductionId: null,
      query: {
        page: 1,
        limit: 100,
        keyword: '',
      },
      activeTab: ref('contrats'),
      filters: reactive({
        contrats: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '' },
        formations: { campagne: '', controleur: '' },
        controle_interne: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' },
        parcellaire: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' },
        bon_livraison: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' },
        collecte: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' },
      }),
      hasLoadedFormationData: false,
    };
  },
  computed: {
  },
  created() {
    this.loading = true;
    this.getCampagneList();
    this.campEnCours();
    this.getUniteProdList();
    this.getVillagesList();
    this.getRegionsList();
  },
  methods: {
    checkPermission,
    checkRole,
    uppercaseFirst(str) {
      if (!str) {
        return '';
      }
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    async download(type) {
      this.downloading = true;
      try {
        const endpoint = type === 'collecte' ? 'collectes' : type;
        const response = await downloadResource.download(endpoint, this.filters[type]);
        const blob = response.data || response; // selon implémentation de Resource
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.genererNomFichier(type);
        link.click();
        // this.genererNomFichier(type);
      } catch (err) {
        console.error('Erreur téléchargement groupé:', err);
        // si le code d'erreur est 404, on affiche un message spécifique
        if (err.response && err.response.status === 404) {
          this.$message.error('Aucun fichier trouvé pour les critères sélectionnés');
        } else {
          // pour les autres erreurs, on affiche un message générique
          this.$message.error('Erreur lors du téléchargement');
        }
      } finally {
        this.downloading = false;
      }
    },
    async handleTabClick(tab) {
      if (tab.name === 'contrats') {
        await this.initSearch();
      } else if (tab.name === 'formation' && !this.hasLoadedFormationData) {
        this.filters.formations.campagne = this.campagne_encours.id;
        this.getControleurList();
        this.hasLoadedFormationData = true;
      } else if (tab.name === 'controle_interne') {
        this.filters.controle_interne.campagne = this.campagne_encours.id;
      } else if (tab.name === 'parcellaire') {
        this.filters.parcellaire.campagne = this.campagne_encours.id;
      } else if (tab.name === 'bon_livraison') {
        this.filters.bon_livraison.campagne = this.campagne_encours.id;
      } else if (tab.name === 'collecte') {
        this.filters.collecte.campagne = this.campagne_encours.id;
      }
    },
    async getUniteProdList() {
      const { data } = await uniteProdResource.list();
      console.log('UNITE PRODUCTION', data);
      this.unite_productions = data;
      this.loading = false;
    },
    async getCampagneList() {
      const { data } = await campResource.list();
      this.campagnes_agricoles = data;
    },
    async getRegionsList() {
      try {
        const { data } = await regionResource.sublist('?typeApi="all"', { limit: 1000 });
        this.regions = data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des régions:', error);
        this.regions = [];
      }
    },
    async loadAllZonesAndCommunes() {
      try {
        const { data: zonesData } = await zoneResource.sublist('?typeApi="all"', { limit: 1000 });
        this.zones = zonesData || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des zones:', error);
        this.zones = [];
      }

      try {
        const { data: communesData } = await communeResource.sublist('?typeApi="all"', { limit: 1000 });
        this.communes = communesData || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des communes:', error);
        this.communes = [];
      }
    },
    async onRegionChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser uniquement les sélections enfants si la région est désélectionnée
      if (!filter.region) {
        filter.zone = '';
        filter.commune = '';
        filter.village = '';
      }
      // Toujours réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async onZoneChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser uniquement les sélections enfants si la zone est désélectionnée
      if (!filter.zone) {
        filter.commune = '';
        filter.village = '';
      }
      // Toujours réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async onCommuneChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser uniquement les sélections enfants si la commune est désélectionnée
      if (!filter.commune) {
        filter.village = '';
      }
      // Toujours réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async onVillageChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async reloadAllFields(filterType) {
      const filter = this.filters[filterType];

      // 1. Charger les zones si une région est sélectionnée
      if (filter.region) {
        try {
          const { data } = await zoneResource.sublist(`?typeApi="all"&region_id=${filter.region}`, { limit: 1000 });
          this.zones = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des zones:', error);
          this.zones = [];
        }
      } else {
        // Si pas de région, charger toutes les zones
        try {
          const { data } = await zoneResource.sublist('?typeApi="all"', { limit: 1000 });
          this.zones = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des zones:', error);
          this.zones = [];
        }
      }

      // 2. Charger les communes selon zone ou région
      if (filter.zone) {
        try {
          const { data } = await communeResource.sublist(`?typeApi="all"&zone_id=${filter.zone}`, { limit: 1000 });
          this.communes = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des communes:', error);
          this.communes = [];
        }
      } else if (filter.region) {
        // Si zone non sélectionnée mais région oui, utiliser region_id directement
        try {
          const { data } = await communeResource.sublist(`?typeApi="all"&region_id=${filter.region}`, { limit: 1000 });
          this.communes = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des communes:', error);
          this.communes = [];
        }
      } else {
        // Si rien n'est sélectionné, charger toutes les communes
        try {
          const { data } = await communeResource.sublist('?typeApi="all"', { limit: 1000 });
          this.communes = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des communes:', error);
          this.communes = [];
        }
      }

      // 3. Charger les villages selon commune, zone ou région
      if (filter.commune) {
        try {
          const { data } = await villageResource.list({ commune_id: filter.commune, limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      } else if (filter.zone) {
        // Si commune non sélectionnée mais zone oui, utiliser zone_id directement
        try {
          // Utiliser zone_id directement au lieu de boucler sur les communes
          const { data } = await villageResource.list({ zone_id: filter.zone, limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      } else if (filter.region) {
        // Si zone et commune non sélectionnées mais région oui, utiliser region_id directement
        try {
          // Utiliser region_id directement au lieu de boucler sur les communes
          const { data } = await villageResource.list({ region_id: filter.region, limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      } else {
        // Si rien n'est sélectionné, charger tous les villages
        try {
          const { data } = await villageResource.list({ limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      }

      // 4. Filtrer les unités de production selon les localités sélectionnées
      await this.filterUniteProductionsByLocalites(filterType);
    },
    async filterUniteProductionsByLocalites(filterType) {
      const filter = this.filters[filterType];
      const params = {};

      // Priorité : village > commune > zone > région
      if (filter.village) {
        params.village_id = filter.village;
      } else if (filter.commune) {
        params.commune_id = filter.commune;
      } else if (filter.zone) {
        params.zone_id = filter.zone;
      } else if (filter.region) {
        params.region_id = filter.region;
      }

      if (Object.keys(params).length > 0) {
        try {
          // Utiliser l'endpoint spécifique pour filtrer par localités
          const response = await uniteProdResource.sublist('/filter-by-localites', params);
          // L'intercepteur axios retourne déjà response.data du serveur
          // sendResponse retourne {success: true, data: [...], message: "..."}
          // Donc response est {success, data, message} et response.data contient le tableau
          this.unite_productions = response.data || [];
        } catch (error) {
          console.error('Erreur lors du filtrage des unités de production:', error);
          this.unite_productions = [];
        }
      } else {
        await this.getUniteProdList();
      }
    },
    async getUPGroupementsList(filterTypeOrUpId) {
      // Support de l'ancienne signature pour compatibilité
      let filterType = 'controle_interne';
      let upId = null;

      if (typeof filterTypeOrUpId === 'string') {
        filterType = filterTypeOrUpId;
        const filter = this.filters[filterType];
        upId = filter.unite_production;
      } else {
        upId = filterTypeOrUpId;
      }

      // Réinitialiser les sélections dépendantes
      const filter = this.filters[filterType];
      filter.groupement = '';
      filter.producteur = '';
      this.producteurs = [];

      if (!upId) {
        this.groupements = [];
        return;
      }

      const params = { unite_production_id: upId };

      // Ajouter les filtres de localités si disponibles
      if (filter.village) {
        params.village_id = filter.village;
      } else if (filter.commune) {
        params.commune_id = filter.commune;
      } else if (filter.zone) {
        params.zone_id = filter.zone;
      } else if (filter.region) {
        params.region_id = filter.region;
      }

      try {
        if (Object.keys(params).length > 1) {
          // Filtrer par localités via l'API
          const response = await new Resource('groupements').sublist('/filter-by-localites', params);
          // L'intercepteur axios retourne déjà response.data du serveur
          // sendResponse retourne {success: true, data: [...], message: "..."}
          // Donc response est {success, data, message} et response.data contient le tableau
          this.groupements = response.data || [];
        } else {
          // Utiliser l'ancienne méthode si pas de filtre localité
          this.groupements = this.unite_productions.find((up) => up.id === upId)?.groupements || [];
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des groupements:', error);
        this.groupements = [];
      }
    },
    async getGroupProducteursList(filterTypeOrGroupId) {
      // Support de l'ancienne signature pour compatibilité
      let filterType = 'controle_interne';
      let groupId = null;

      if (typeof filterTypeOrGroupId === 'string') {
        filterType = filterTypeOrGroupId;
        const filter = this.filters[filterType];
        groupId = filter.groupement;
      } else {
        groupId = filterTypeOrGroupId;
      }

      if (!groupId) {
        this.producteurs = [];
        return;
      }

      this.loading = true;
      const filter = this.filters[filterType];
      const params = { groupement_id: groupId };

      // Ajouter les filtres de localités si disponibles
      if (filter.village) {
        params.village_id = filter.village;
      } else if (filter.commune) {
        params.commune_id = filter.commune;
      } else if (filter.zone) {
        params.zone_id = filter.zone;
      } else if (filter.region) {
        params.region_id = filter.region;
      }

      try {
        if (Object.keys(params).length > 1) {
          // Filtrer par localités via l'API
          const response = await new Resource('producteurs').sublist('/filter-by-localites', params);
          // L'intercepteur axios retourne déjà response.data du serveur
          // sendResponse retourne {success: true, data: [...], message: "..."}
          // Donc response est {success, data, message} et response.data contient le tableau
          this.producteurs = response.data || [];
          this.loading = false;
        } else {
          // Utiliser l'ancienne méthode si pas de filtre localité
          await groupementProducteurResource.get(groupId)
            .then(response => {
              this.loading = false;
              this.producteurs = response.data;
            })
            .catch(error => {
              this.loading = false;
              console.error('Erreur lors de la récupération des producteurs:', error);
              this.$message.error('Erreur lors de la récupération des producteurs');
            });
        }
      } catch (error) {
        this.loading = false;
        console.error('Erreur lors de la récupération des producteurs:', error);
        this.$message.error('Erreur lors de la récupération des producteurs');
      }
    },
    async campEnCours(){
      const { data } = await campResource.sublist('/en_cours');
      this.campagne_encours = data;
      this.filters.contrats.campagne = data.id;
      this.filters.bon_livraison.campagne = data.id;
    },
    genererNomFichier(type) {
      // Récupère les filtres selon le type
      const filtres = this.filters[type] || {};
      let campagne = '';
      let nomUp = '';
      let nomGroupement = '';
      let nomControleur = '';

      // Récupère la période de la campagne sélectionnée
      if (filtres.campagne && this.campagnes_agricoles) {
        const camp = this.campagnes_agricoles.find(c => c.id === filtres.campagne);
        campagne = camp ? camp.periode : '';
      }

      // Récupère le nom de l'unité de production sélectionnée
      if (filtres.unite_production && this.unite_productions) {
        const up = this.unite_productions.find(u => u.id === filtres.unite_production);
        nomUp = up ? up.nom : '';
      }

      // Récupère le nom du groupement sélectionné
      if (filtres.groupement && this.groupements) {
        console.log('filtres.groupement', filtres.groupement);
        const group = this.groupements.find(g => g.id === filtres.groupement);
        nomGroupement = group ? group.nom : '';
      }

      // Récupère le nom du contrôleur sélectionné
      if (filtres.controleur && this.controleurs) {
        const controleur = this.controleurs.find(c => c.id === filtres.controleur);
        nomControleur = controleur ? controleur.nom : '';
      }
      // Fonction utilitaire pour nettoyer le nom (équivalent PHP)
      function genererNomFichierZip(nom) {
        if (!nom) {
          return '';
        }
        // Remplace les caractères accentués et spéciaux
        nom = nom.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        nom = nom.replace(/[^A-Za-z0-9]/g, '_');
        nom = nom.replace(/_+/g, '_');
        nom = nom.replace(/^_+|_+$/g, '');
        return nom.toLowerCase();
      }

      let filename = `fiches_${type}`;
      if (nomGroupement) {
        filename = `fiches_${type}_Group_${genererNomFichierZip(nomGroupement)}_${campagne}.zip`;
      } else if (nomUp) {
        filename = `fiches_${type}_UP_${genererNomFichierZip(nomUp)}_${campagne}.zip`;
      } else if (nomControleur) {
        filename = `fiches_${type}_Controleur_${genererNomFichierZip(nomControleur)}_${campagne}.zip`;
      } else if (campagne) {
        filename = `fiches_${type}_${campagne}.zip`;
      } else {
        filename = `fiches_${type}.zip`;
      }
      return filename;
    },
    async getControleurList() {
      const { data } = await controleurResource.list();
      this.controleurs = data;
    },
    async getVillagesList() {
      try {
        const { data } = await villageResource.list({ limit: 1000 });
        this.villages = data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des villages:', error);
        this.villages = [];
      }
    },
    async initSearch() {
      // Réinitialiser tous les filtres
      this.filters.contrats = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '' };
      this.filters.formations = { campagne: '', controleur: '' };
      this.filters.controle_interne = { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' };
      this.filters.parcellaire = { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' };
      this.filters.bon_livraison = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' };
      this.filters.collecte = { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' };

      // Vider les listes
      this.zones = [];
      this.communes = [];
      this.villages = [];
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs
      await Promise.all([
        this.getRegionsList(),
        this.loadAllZonesAndCommunes(),
        this.getVillagesList(),
        this.getUniteProdList(),
        this.getCampagneList(),
        this.getControleurList(),
      ]);

      this.activeTab = 'contrats';
    },
  },
};
</script>
<style>
.fiches-tabs {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
</style>
